import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useTheme } from "@mui/material/styles";
const StageStart = (t0)=>{
    const $ = c(6);
    const { first, status } = t0;
    const { tokens } = useTheme();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ jsx("path", {
            d: "M0 8C0 3.58172 3.58172 0 8 0L12 0V24H8C3.58172 24 0 20.4183 0 16V8Z"
        });
        $[0] = t1;
    } else t1 = $[0];
    const rounded = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ jsx("path", {
            d: "M0 0H12V24H0L4.66513 18.4018C7.75552 14.6934 7.75551 9.30662 4.66513 5.59816L0 0Z"
        });
        $[1] = t2;
    } else t2 = $[1];
    const angled = t2;
    const t3 = "initial" === status ? tokens.colors.bg.greyscale.primary : tokens.colors.original.brand.primary;
    const t4 = "active" === status ? 0.6 : 1;
    const t5 = first ? rounded : angled;
    let t6;
    if ($[2] !== t3 || $[3] !== t4 || $[4] !== t5) {
        t6 = /*#__PURE__*/ jsx("svg", {
            width: "12",
            height: "24",
            viewBox: "0 0 12 24",
            fill: t3,
            fillOpacity: t4,
            xmlns: "http://www.w3.org/2000/svg",
            children: t5
        });
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = t6;
    } else t6 = $[5];
    return t6;
};
export { StageStart };
